export default {
    delivery: {
        product: {
            tracking: "Seguimiento",
            quantity: "Cantidad"
        }
    }
}